import { hotkeyHint } from "@/hooks/useCoverageBetaHotkeys";
import { useCoverageBetaStore } from "@/store/useCoverageBetaStore";
import { QUERY_IMAGE_CONTROL_ICON_SIZE } from "@/utils/utils";
import { ActionIcon, Tooltip } from "@mantine/core";
import { IconUser } from "@tabler/icons-react";

export const DrawPersonMode = () => {
  const activeMode = useCoverageBetaStore((s) => s.activeMode);
  const setActiveMode = useCoverageBetaStore((s) => s.setActiveMode);
  const recordInteraction = useCoverageBetaStore((s) => s.recordInteraction);
  const thisMode = "draw-person";

  return (
    <Tooltip
      label={`Draw Person (${hotkeyHint("draw_person")})`}
      position="right"
    >
      <ActionIcon
        size="sm"
        variant={activeMode === thisMode ? "filled" : "light"}
        color={activeMode === thisMode ? "orange" : "gray"}
        onClick={() => {
          setActiveMode(thisMode);
          recordInteraction("draw_person", "click");
        }}
      >
        <IconUser size={QUERY_IMAGE_CONTROL_ICON_SIZE} />
      </ActionIcon>
    </Tooltip>
  );
};
